import { render, staticRenderFns } from "./indexHomeOther.vue?vue&type=template&id=5e3da6eb&scoped=true&"
import script from "./indexHomeOther.vue?vue&type=script&lang=js&"
export * from "./indexHomeOther.vue?vue&type=script&lang=js&"
import style0 from "./indexHomeOther.vue?vue&type=style&index=0&id=5e3da6eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3da6eb",
  null
  
)

export default component.exports